import {
    getItemFromLocalStorage,
    setItemToLocalStorage,
} from '../network/storage';

const KEY_PREFIX = 'advert_draft:';
const RETURN_KEY = 'advert_return_path';
const TTL_MS = 7 * 24 * 60 * 60 * 1000;
const RETURN_TTL_MS = TTL_MS;
const LANGS = ['ru', 'en', 'ua', 'ge'];

const keyFor = (section) => `${KEY_PREFIX}${section}`;

const PLACEMENT_CORPORATE_SUBTYPES = new Set([
    'autoservice',
    'painting',
    'carwash',
    'tyreservice',
]);

export const advertIntentFromPath = (pathname) => {
    if (!pathname) return 'auto';
    const segments = pathname.split('/').filter(Boolean);
    if (segments.length && LANGS.includes(segments[0])) segments.shift();
    if (segments[0] === 'region-service') return 'service';
    if (
        segments[0] === 'company' &&
        (segments[1] || '').split(/[?#]/)[0] === 'service'
    ) {
        return 'service';
    }
    if (
        segments[0] === 'placement' &&
        PLACEMENT_CORPORATE_SUBTYPES.has(segments[1])
    ) {
        return 'service';
    }
    return 'auto';
};

export const saveAdvertDraft = (section, values) => {
    if (!section || typeof window === 'undefined') return;
    try {
        setItemToLocalStorage(keyFor(section), {
            values,
            savedAt: Date.now(),
        });
    } catch {}
};

export const loadAdvertDraft = (section) => {
    if (!section || typeof window === 'undefined') return null;
    try {
        const draft = getItemFromLocalStorage(keyFor(section));
        if (!draft || !draft.values) return null;
        if (Date.now() - (draft.savedAt || 0) > TTL_MS) {
            clearAdvertDraft(section);
            return null;
        }
        return draft.values;
    } catch {
        return null;
    }
};

export const clearAdvertDraft = (section) => {
    if (!section || typeof window === 'undefined') return;
    try {
        localStorage.removeItem(keyFor(section));
    } catch {}
};

export const clearAllAdvertDrafts = () => {
    if (typeof window === 'undefined') return;
    try {
        const keys = [];
        for (let i = 0; i < localStorage.length; i++) {
            const k = localStorage.key(i);
            if (k && k.startsWith(KEY_PREFIX)) keys.push(k);
        }
        keys.forEach((k) => localStorage.removeItem(k));
    } catch {}
};

export const hasAnyAdvertDraft = () => {
    if (typeof window === 'undefined') return false;
    try {
        for (let i = 0; i < localStorage.length; i++) {
            const k = localStorage.key(i);
            if (!k || !k.startsWith(KEY_PREFIX)) continue;
            const draft = getItemFromLocalStorage(k);
            if (!draft || !draft.values) continue;
            if (Date.now() - (draft.savedAt || 0) <= TTL_MS) return true;
        }
        return false;
    } catch {
        return false;
    }
};

export const loadAdvertDraftMeta = (section) => {
    if (!section || typeof window === 'undefined') return null;
    try {
        const draft = getItemFromLocalStorage(keyFor(section));
        if (!draft || !draft.values) return null;
        const savedAt = Number(draft.savedAt) || 0;
        if (Date.now() - savedAt > TTL_MS) {
            clearAdvertDraft(section);
            return null;
        }
        return { values: draft.values, savedAt };
    } catch {
        return null;
    }
};

export const hasResumableDraft = () => hasAnyAdvertDraft();

export const saveAdvertReturn = (path) => {
    if (!path || typeof window === 'undefined') return;
    try {
        setItemToLocalStorage(RETURN_KEY, { path, savedAt: Date.now() });
    } catch {}
};

export const loadAdvertReturn = () => {
    if (typeof window === 'undefined') return null;
    try {
        const entry = getItemFromLocalStorage(RETURN_KEY);
        if (!entry || !entry.path) return null;
        if (Date.now() - (entry.savedAt || 0) > RETURN_TTL_MS) {
            clearAdvertReturn();
            return null;
        }
        return entry.path;
    } catch {
        return null;
    }
};

export const clearAdvertReturn = () => {
    if (typeof window === 'undefined') return;
    try {
        localStorage.removeItem(RETURN_KEY);
    } catch {}
};
